import { useController } from 'react-hook-form';

import SearchField, { type SearchFieldProps } from 'components/SearchField';
import type { DistributiveOmit } from 'types';

import { useFormContext } from './hooks';

type Props = DistributiveOmit<
	SearchFieldProps,
	'isLoading' | 'name' | 'onBlur' | 'onChange' | 'onInputClearClick' | 'value'
> & { name: string };

/** Search field connected to the surrounding form. */
export default function SearchInput({ disabled, name, ...rest }: Props) {
	const { hookFormContext } = useFormContext();
	const { field } = useController({ defaultValue: '', disabled, name });

	return (
		<SearchField
			{...rest}
			{...field}
			isLoading={hookFormContext.formState.isSubmitting}
			onInputClearClick={() => {
				// TODO: Reset only this field with resetField(name). The whole form
				// is reset for now since forms rely on it clearing root errors.
				hookFormContext.reset();
			}}
		/>
	);
}
SearchInput.displayName = 'ReactHookForm_SearchInput';
